import "./OurCraft.module.css";
import SolidTrustNavigation from "@/reusable_sections/Header";
import ThePortfolio from "./sections/ThePortfolio";
import ProjectInsights from "./sections/ProjectInsights";
import Footer from "@/reusable_sections/Footer";
export default function OurCraftPage() {
  return <div>
      <SolidTrustNavigation />
      <ThePortfolio />
      <ProjectInsights />
      <Footer />
    </div>;
}